var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chapter-box-container mb-4"},[_c('div',{staticClass:"chapter-box _h-100",class:{ finished: _vm.chapterFinished },on:{"click":_vm.select}},[_c('h3',{staticClass:"chapter-label"},[_vm._v(_vm._s(_vm.data.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }